module.exports = __webpack_public_path__ + "assets/3d00f08a3024f0b7b8f77975e9354f7e.json";